import { createCell, getSortTableKey } from './table'

const textTypeList = ['input', 'number', 'select', 'date']
const isTextItem = (type) => { return textTypeList.includes(type) }
const isImageItem = (type) => { return type === 'image' }
const isTableItem = (type) => { return type === 'table' }
const createTextItem = (labelItem, form) => {
  const { id: tagId } = labelItem
  const tagType = 'text'
  const text = form[tagId]
  return {
    tagId,
    tagType,
    tagContent: {
      text
    }
  }
}
const createImageItem = (labelItem, form, imageTypeInfo) => {
  const { id: tagId } = labelItem
  const tagType = 'image'
  const imageType = imageTypeInfo[tagId].fileType.toUpperCase()
  const imageUrl = form[tagId]
  return {
    tagId,
    tagType,
    tagContent: {
      imageType,
      imageUrl,
      'align': 'center'
    }
  }
}
const createTableItem = (labelItem, form) => {
  const { id: tagId, type: tagType, option: { columnDefs }} = labelItem
  const table = form[tagId]
  const rows = []
  const sortCol = getSortTableKey(columnDefs) // ['name','address]
  // 创建表格
  table.forEach(tableData => {
    const rowInstance = {
      cells: sortCol.map(key => {
        return createCell(tableData[key])
      })
      // 'rowStyle': {
      //   'height': 20.0 // 行高，单位cm
      // }
    }
    rows.push(rowInstance)
  })
  // 创建，插入表头
  const headerInstance = {
    cells: columnDefs.map(column => { return createCell(column.label) })
  }
  rows.unshift(headerInstance)
  // 'tableStyle': {
  //   'width': 50.0, // 表格整体宽度， 单位cm
  //   'colWidths': [25.0, 25.0], // 表格列宽度，单位cm
  //   'align': 'center' // 对齐方式, center:居中对齐，left:左对齐，right:右对齐
  // },
  // 'mergeRule': {
  //   'mapping': [ // 合并单元格范围，如 0行0列 和0行1列进行合并
  //     {
  //       'from': { // 起始单元格
  //         'rowNumber': 0, // 行编号
  //         'columnNumber': 0 // 列编号
  //       },
  //       'to': { // 结束单元格
  //         'rowNumber': 0, // 行编号
  //         'columnNumber': 1 // 列编号
  //       }
  //     }
  //   ]
  // }
  // })
  return {
    tagId,
    tagType,
    tagContent: { rows }
  }
}
const createTagItem = (labelItem, form, imageTypeInfo) => {
  const { type } = labelItem
  let fn = null
  if (isTextItem(type)) {
    fn = createTextItem
  }
  if (isImageItem(type)) {
    fn = createImageItem
  }
  if (isTableItem(type)) {
    fn = createTableItem
  }
  return fn(labelItem, form, imageTypeInfo)
}

export const createTemplateRenderData = (config, labelList, form, imageTypeInfo) => {
  const { document } = config
  const fileUrl = document.url
  const targetFileName = '协议名称测试' + new Date().getTime() + '.docx'
  const data = {
    fileUrl,
    targetFileName,
    tagList: labelList.filter(item => {
      return form[item.id]
    }).map(item => {
      return createTagItem(item, form, imageTypeInfo)
    })
  }
  return data
}
